<div class="grid grid-cols-7 gap-2 w-full px-6" style="margin-bottom: 20vh">
    <div class="col-span-5 mt-6 w-full">
        <div class="bg-card shadow rounded-2xl">
            <div class="text-center p-4 header rounded-t-2xl grid grid-cols-12">
                <button class="col-span-1 text-left" (click)="openInfo()">
                    <mat-icon svgIcon="heroicons_solid:information-circle" matPrefix class="text-white"></mat-icon>
                </button>

                <h1 class="col-span-11 text-center">
                    <b> CRITICAL DEVICE FUNCTION TEST (CDFT) FORM </b>
                </h1>
            </div>

            <div *ngIf="isPendingSync" class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4 mt-4 mx-6">
                <div class="flex items-center gap-2">
                    <mat-icon class="text-yellow-600" svgIcon="heroicons_solid:clock"></mat-icon>
                    <div>
                        <p class="text-sm font-medium text-yellow-800">
                            Offline Submit Pending
                        </p>
                        <p class="text-xs text-yellow-700">
                            This record has been submitted for review offline
                            and will be synced automatically when you are back
                            online.
                        </p>
                    </div>
                </div>
            </div>

            <mat-accordion class="w-full">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title> HEADER </mat-panel-title>
                    </mat-expansion-panel-header>

                    <header [isViewOnly]="false"></header>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            XMAS TREE & WELLHEAD VALVE TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <wellhead-valve [isViewOnly]="false"></wellhead-valve>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            SSSV / DOWNHOLE BARRIER TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <sssv-barrier [isViewOnly]="false"></sssv-barrier>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            CONTROL LINE TEST REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <control-line [isViewOnly]="false"></control-line>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            ANNULUS PRESSURE MONITORING REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <app-annulus-pressure-table [isViewOnly]="false"></app-annulus-pressure-table>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            WELLHEAD SUBSIDENCE MONITORING REPORT
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <wellhead-subsidence [isViewOnly]="false"></wellhead-subsidence>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            CDFT OVERALL REMARKS
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-form-field class="w-full">
                        <textarea matInput cdkTextareaAutosize name="overallRemarks" [(ngModel)]="state.overallRemarks"
                            cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10"></textarea>
                    </mat-form-field>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="text-center p-4 header rounded-b-2xl">
                <h1>
                    <b>
                        <span> SAFETY FIRST! </span><br />
                        Please comply with all safety WARNINGS prior to
                        performing any task.
                    </b>
                </h1>
            </div>
        </div>
    </div>
    <div class="col-span-2 rounded-b-2xl mt-6 sticky w-full">
        <div class="bg-card shadow rounded-2xl top-2">
            <app-cdft-detail [isViewOnly]="true"></app-cdft-detail>
        </div>

        <div *ngIf="showWfamStatus" class="bg-card shadow rounded-2xl mt-4" style="top: 380px">
            <app-wfam-detail> </app-wfam-detail>
        </div>

        <div *ngIf="isInputError" class="bg-card shadow rounded-2xl sticky mt-4">
            <app-cdft-error-details> </app-cdft-error-details>
        </div>
    </div>
</div>

<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="location.back()">
            Back
        </button>
        <button *ngIf="isNotReady" [matMenuTriggerFor]="menu" class="btn btn-outline btn-default">
            Save
            <mat-icon svgIcon="heroicons_outline:chevron-up"></mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="save()">
                <span>Save</span>
            </button>
            <button mat-menu-item (click)="save(status.READY)" [disabled]="disabledSubmit()">
                <span>Submit for Review</span>
            </button>
        </mat-menu>
    </div>
</div>